import { Text, Space, Title, Box, useMantineTheme } from "@mantine/core";
import React, { FC } from "react";
import { ProductFromGetOrderByUniqueAttributeQuery } from "/@/shared/types/products/products.types";
import { GetOrderByUniqueAttributeQuery } from "/@/generated/graphql";

import {
  getProductTeeth,
  getAllTeeths,
  Product,
  ItemsDescription,
  filterProductsForRdv2Display,
  DentalArchesSvg,
} from "@jasper/shared";

type CreateProductSummarySideBarProps = {
  product: ProductFromGetOrderByUniqueAttributeQuery | Product;
  patient: GetOrderByUniqueAttributeQuery["getOrderByUniqueAttribute"]["patient"];
  order?: GetOrderByUniqueAttributeQuery["getOrderByUniqueAttribute"];
  isBothJaws?: boolean;
  removableItemChoicesData?: any;
  isRdv2Continuation?: boolean;
};

export const CreateProductSummarySideBar: FC<
  CreateProductSummarySideBarProps
> = ({
  product,
  patient,
  order,
  isBothJaws,
  removableItemChoicesData,
  isRdv2Continuation,
}) => {
  const theme = useMantineTheme();

  // for PAC RDV2 continuation, filter out products from previous RDV
  const productsToDisplay = filterProductsForRdv2Display(
    order?.products ?? [],
    isRdv2Continuation ?? false
  );

  return (
    <Box
      style={theme => ({
        height: "100%",
        backgroundColor: theme.colors.primaryLight[9],
        padding: theme.spacing.sm,
      })}
    >
      <Title order={3}>Résumé</Title>
      <Space h="sm" />
      <Text
        style={{
          borderRadius: "50px",
          padding: "10px",
          backgroundColor: theme.colors.primaryLight[6],
          width: "fit-content",
        }}
      >
        {patient
          ? `Patient ${patient.firstName} ${patient.lastName}`
          : "non attribué"}
      </Text>
      <Box
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        }}
      >
        <DentalArchesSvg
          teeth={
            isBothJaws ? getAllTeeths() : getProductTeeth(product as Product)
          }
          width={300}
          height={400}
        />
      </Box>
      <Box>
        {productsToDisplay.map(item => (
          <ItemsDescription
            key={item.id}
            product={item as unknown as Product}
            shouldTranslate={false}
            choicesData={removableItemChoicesData}
          />
        ))}
      </Box>
    </Box>
  );
};
